import type { FormAgreementLink } from 'pkg/api/models/agreement';
import { ConsentInteractionType } from 'pkg/api/models/agreement';

export const isRequired = (link: FormAgreementLink): boolean =>
	link.consentInteractionType === ConsentInteractionType.Required;
